<template>
  <Teleport to="body">
    <div class="sheet" :class="{ 'is-open': isOpen }">
      <button aria-label="close" class="sheet-close-btn" @click="close">
        <icon-close-bold class="text-[24px] text-gray-1 !mb-0" />
      </button>
      <slot />
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { ref, defineExpose } from "vue";

const emit = defineEmits(["close"]);
const isOpen = ref(false);

const open = () => {
  isOpen.value = true;
};

const close = () => {
  isOpen.value = false;
  emit("close");
};

// Expose functions to parent
defineExpose({ open, close });
</script>

<style scoped>
/* Full-screen sheet */
.sheet {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: white;
  transform: translateY(-100%);
  opacity: 0;
  transition:
    transform 0.3s cubic-bezier(0, 0, 0.2, 1),
    opacity 0.3s cubic-bezier(0, 0, 0.2, 1);
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  z-index: 1002;
  padding-top: 80px;
}

/* Open state */
.sheet.is-open {
  transform: translateY(0);
  opacity: 1;
}

/* Close button */
.sheet-close-btn {
  position: absolute;
  top: 40px;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  @apply ltr:right-5 rtl:left-5;
}
</style>
